import React from "react";
import { motion } from "framer-motion";

export interface TechIconProps {
  children: React.ReactNode;
  delay: number;
  label: string;
}

const TechIcon: React.FC<TechIconProps> = ({ children, delay, label }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ delay }}
    whileHover={{ scale: 1.2, rotate: 10 }}
    viewport={{ once: true }}
    className="flex flex-col items-center gap-2"
  >
    <div className="w-16 h-16 rounded-xl glass flex items-center justify-center text-3xl text-slate-300 hover:text-white transition-colors">
      {children}
    </div>
    <span className="text-xs text-slate-400">{label}</span>
  </motion.div>
);

export default TechIcon;
